import { render, staticRenderFns } from "./EditionPanel.vue?vue&type=template&id=3af674f7&scoped=true&"
import script from "./EditionPanel.vue?vue&type=script&lang=js&"
export * from "./EditionPanel.vue?vue&type=script&lang=js&"
import style0 from "./EditionPanel.vue?vue&type=style&index=0&id=3af674f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af674f7",
  null
  
)

export default component.exports